<div class="modal-header text-center" style="border-bottom: none">

    <p>
      You already have some time tracked for the job <strong>{{ jobName }}</strong> today ({{ currentTimeTracked }})
      <br /> <br />
      Do you want to add time to the existing timer entry for today?
    </p>
  </div>
  <div class="modal-footer">
    <div class="btn btn-default pull-left" aria-label="Cancel" (click)="cancel()">
      New time entry
    </div>
    <div
      class="btn btn-primary pull-right"
      aria-label="Confirm"
      (click)="confirm()"
    >
      Add to existing entry
    </div>
  </div>
  